export default {
      id: "icon--payment-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--payment-usage",
      toString: function () {
        return this.url;
      }
    }